// Catalog of menu items used both by the sidebar (Layout) and the user
// permissions form (Users). Each entry has a stable `key` persisted on the
// user document, a Spanish label, and (optionally) the roles that can ever
// access it (e.g. admin-only sections).
export const MENU_ITEMS = [
  { key: "dashboard", label: "Panel" },
  { key: "suppliers", label: "Proveedores" },
  { key: "customers", label: "Clientes" },
  { key: "flower-types", label: "Tipos de Flores" },
  { key: "products", label: "Productos" },
  { key: "promotions", label: "Promociones" },
  { key: "services", label: "Servicios" },
  { key: "kardex", label: "Kardex" },
  { key: "pos", label: "POS" },
  { key: "invoices", label: "Facturas" },
  { key: "credit-notes", label: "Notas de Crédito" },
  { key: "retentions", label: "Retenciones" },
  { key: "remission-guides", label: "Guías de Remisión" },
  { key: "reports", label: "Reportes" },
  { key: "sri-diagnostics", label: "Diagnóstico SRI", adminOnly: true },
  { key: "users", label: "Usuarios", adminOnly: true },
  { key: "settings", label: "Ajustes", adminOnly: true },
];

export const DEFAULT_PERMISSIONS = {
  admin: MENU_ITEMS.map((m) => m.key),
  vendedor: [
    "dashboard", "customers", "products", "promotions", "services",
    "pos", "invoices", "credit-notes", "reports",
  ],
  bodeguero: [
    "dashboard", "suppliers", "flower-types", "products",
    "kardex", "remission-guides", "reports",
  ],
};

export function hasMenuAccess(user, key) {
  if (!user) return false;
  if (user.role === "admin") return true;
  return Array.isArray(user.permissions) && user.permissions.includes(key);
}
